import * as React from 'react'
import classNames from 'classnames'

const ActionButton = ({
  type,
  onClick,
  children,
}: {
  type: string
  onClick?: () => void
  children: React.ReactNode | string
}) => {
  const baseClasses =
    'flex items-center justify-center font-europa-yu text-xs leading-5 tracking-wider font-bold cursor-pointer flex-shrink-0 desktop:w-[91px] desktop:h-[36px] desktop:rounded sp:w-[24.27vw] sp:h-[9.6vw] sp:rounded-[1.07vw]'

  const typeClasses = {
    primary: 'bg-text-black text-white',
    normal: 'border border-text-black text-text-black',
    'multi-creator': 'bg-multi-creator-lp-red text-white',
    loading: 'cursor-progress',
    disabled: 'bg-border-gray-0 text-white cursor-not-allowed',
  }

  return (
    <button
      type="button"
      className={classNames(
        baseClasses,
        typeClasses[type as keyof typeof typeClasses] || ''
      )}
      onClick={type === 'disabled' ? undefined : onClick}
    >
      {children}
    </button>
  )
}

export const UpdateActionButton = ({ onClick }: { onClick?: () => void }) => (
  <ActionButton type="normal" onClick={onClick}>
    変更する
  </ActionButton>
)
